<template>
  <LinkButton
    v-if="showCameraLink"
    tag="a"
    to="/downloads/smarthome-unterstuetzte-kameras.pdf"
    target="_blank"
    text
    class="camera-link"
  >
    Unsere Kameras im Überblick (PDF)
    <Arrow
      direction="right"
      class="camera-link__icon"
      tag="span"
    />
  </LinkButton>
</template>

<script lang="ts" setup>
import { LinkButton, Arrow } from '@i22team/td-longtail-vue-components';

export type KameraLinkProps = {
  offer?: Offer;
};

const props = withDefaults(defineProps<KameraLinkProps>(), {
  offer: undefined,
});

const hasSmarthomeCameraCategory = computed(() => {
  const productCategories = props.offer?.product?.family?.categories;
  if (!productCategories) return false;
  return productCategories.some((category) => category?.categoryNumber === 'T_SHKAMERA');
});

const hasMzaOrMshTag = computed(() => {
  const productTags = props.offer?.product?.tags;
  if (!productTags || productTags.length === 0) return false;

  const lowerCaseTags = productTags
    .filter((tag): tag is string => tag !== undefined)
    .map((tag) => tag.toLowerCase());
  const compatibleTags = ['mzabasic', 'mzapro', 'mshfree', 'mshpro'];

  return lowerCaseTags.some((tag) => compatibleTags.includes(tag));
});

const showCameraLink = computed(() => hasSmarthomeCameraCategory.value && hasMzaOrMshTag.value);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.camera-link {
  display: flex;
  align-items: center;
  gap: 0.5 * $grid-base;
  margin-block: 2 * $grid-base;
  --arrow-position: relative;
  --arrow-width: 0.7em;
  --arrow-height: 0.5em;
}
</style>
